import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { TypesUnitsisTypes } from "../../app/types/genericTables.types";

type UseTypesUnitsisType = {
  typesUnitsis: TypesUnitsisTypes[];
  get: (id: TypesUnitsisTypes["id"]) => TypesUnitsisTypes | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useTypesUnits = create<UseTypesUnitsisType>((set, get) => ({
  loading: false,
  typesUnitsis: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().typesUnitsis.find((type) => type.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/TiposUnidades";
      const { data: response } = await getData(endpoint);
      set(() => ({
        typesUnitsis: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching analysisTypeList:", error);
      set({ loading: false });
    }
  },
}));
